import axios from 'axios';

import getAvailableSlots from './getAvailableSlots';
import getProviderProfile from './getProviderProfile';
import doesCustomerExist from './doesCustomerExist';
import doesCustomerHaveCard from './doesCustomerHaveCard';
import createCustomer from './createCustomer';
import getPaymentFormUrl from './getPaymentFormUrl';
import confirmAppointment from './confirmAppointment';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || '',
});

const apiClient = {
  getAvailableSlots: getAvailableSlots(api),
  getProviderProfile: getProviderProfile(api),
  doesCustomerExist: doesCustomerExist(api),
  doesCustomerHaveCard: doesCustomerHaveCard(api),
  createCustomer: createCustomer(api),
  getPaymentFormUrl: getPaymentFormUrl(api),
  confirmAppointment: confirmAppointment(api),
};

export default apiClient;
